// extracted by mini-css-extract-plugin
export default {"ohHovertab":"SearchpageStyles_ohHovertab__CZloB","onSelectedtab":"SearchpageStyles_onSelectedtab__VidA9","numberAvatar":"SearchpageStyles_numberAvatar__cv5l5"};